import { UI_FIELD_DEFAULT_OPTION, sizeTokenOptionsWithDefault } from './token-options.js';
export const BUTTON_FIELDS = [
    {
        key: 'button.common.radius',
        group: '공용 버튼',
        label: '모서리 둥글기',
        help: '공용 버튼(CommonButton — 확인·저장·구매 등 화면의 큰 버튼)의 모서리 둥글기. 화면에서 둥글기를 따로 정한 버튼은 그대로',
        type: 'enum',
        defaultValue: UI_FIELD_DEFAULT_OPTION,
        options: sizeTokenOptionsWithDefault('radius', '지금 모양 (앱 10.5px·웹 12px)'),
    },
    {
        key: 'button.common.paddingX',
        group: '공용 버튼',
        label: '좌우 안쪽 여백',
        help: '공용 버튼 글자 양옆의 여백. 폭을 화면에서 정한 버튼(가득 찬 버튼)은 폭이 그대로이고 글자 자리만 바뀐다',
        type: 'enum',
        defaultValue: UI_FIELD_DEFAULT_OPTION,
        options: sizeTokenOptionsWithDefault('spacing', '지금 여백 (앱 14px·웹 16px)'),
    },
    {
        key: 'button.common.paddingY',
        group: '공용 버튼',
        label: '위아래 안쪽 여백',
        help: '공용 버튼 글자 위아래의 여백 — 버튼 높이가 이만큼 바뀐다. 테두리형 버튼은 테두리(1px)를 빼서 같은 높이로 맞춘다',
        type: 'enum',
        defaultValue: UI_FIELD_DEFAULT_OPTION,
        options: sizeTokenOptionsWithDefault('spacing', '지금 여백 (앱 10.5px·웹 12px)'),
    },
    {
        key: 'button.common.pressedOpacity',
        group: '공용 버튼',
        label: '누를 때 불투명도',
        help: '공용 버튼을 누르고 있는 동안의 불투명도. 100이면 눌러도 흐려지지 않고, 작을수록 더 흐려진다',
        type: 'integer',
        defaultValue: 60,
        min: 20,
        max: 100,
        unit: '%',
    },
    {
        key: 'button.common.disabledOpacity',
        group: '공용 버튼',
        label: '누를 수 없을 때 불투명도',
        help: '공용 버튼을 누를 수 없을 때(입력이 덜 됐거나 처리 중일 때)의 불투명도. 작을수록 더 흐리게 보인다',
        type: 'integer',
        defaultValue: 50,
        min: 20,
        max: 100,
        unit: '%',
    },
    {
        key: 'button.small.radius',
        group: '작은 버튼',
        label: '모서리 둥글기',
        help: '작은 버튼(SmallButton — 목록 행·카드 안의 팔로우·수정·주문 처리 등 작은 버튼)의 모서리 둥글기. 화면에서 둥글기를 따로 정한 버튼(목록의 팔로우 버튼 등)은 그대로',
        type: 'enum',
        defaultValue: UI_FIELD_DEFAULT_OPTION,
        options: sizeTokenOptionsWithDefault('radius', '지금 모양 (앱 7px·웹 8px)'),
    },
    {
        key: 'button.small.paddingX',
        group: '작은 버튼',
        label: '좌우 안쪽 여백',
        help: '작은 버튼 글자 양옆의 여백',
        type: 'enum',
        defaultValue: UI_FIELD_DEFAULT_OPTION,
        options: sizeTokenOptionsWithDefault('spacing', '지금 여백 (앱 7px·웹 8px)'),
    },
    {
        key: 'button.small.paddingY',
        group: '작은 버튼',
        label: '위아래 안쪽 여백',
        help: '작은 버튼 글자 위아래의 여백. 테두리형 버튼은 테두리(1px)를 빼서 같은 높이로 맞춘다. 높이를 화면에서 정한 버튼(팔로우 등)은 그대로',
        type: 'enum',
        defaultValue: UI_FIELD_DEFAULT_OPTION,
        options: sizeTokenOptionsWithDefault('spacing', '지금 여백 (앱 3.5px·웹 4px)'),
    },
    {
        key: 'button.follow.radius',
        group: '팔로우 버튼',
        label: '큰 팔로우 버튼 둥글기',
        help: '라이브 방송 중 프로필 팝업·방송 종료 화면의 큰 팔로우/팔로잉 버튼(LargeFollowButton) 모서리 둥글기',
        type: 'enum',
        defaultValue: UI_FIELD_DEFAULT_OPTION,
        options: sizeTokenOptionsWithDefault('radius', '지금 모양 (앱 10.5px·웹 12px)'),
    },
];
//# sourceMappingURL=button.js.map